import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';

/**
 * Get CLP Balance from wallets/{uid}/balances.CLP (Source of Truth)
 * @param {string} userId - User ID
 * @returns {Promise<number>} - CLP balance
 */
export const getWalletCLPBalance = async (userId) => {
    try {
        const walletRef = doc(db, 'wallets', userId);
        const walletSnap = await getDoc(walletRef);
        
        if (walletSnap.exists()) {
            const walletData = walletSnap.data();
            return walletData.balances?.CLP || 0;
        }

        return 0;
    } catch (error) {
        console.error('Error getting wallet CLP balance:', error);
        return 0;
    }
};
